import React from "react";
import { motion } from "framer-motion";

const reasons = [
  { num: "01", title: "Mercado más grande de Europa", text: "Más de 4.5 millones de vehículos disponibles en cualquier momento." },
  { num: "02", title: "Cultura automotriz inigualable", text: "Mantenimiento meticuloso y propietarios exigentes con sus vehículos." },
  { num: "03", title: "Mejores precios", text: "Hasta un 25% menos que en España en modelos premium." },
  { num: "04", title: "Variedad de equipamiento", text: "Acceso a versiones, paquetes y opciones imposibles de encontrar localmente." },
];

export const WhyGermany = () => {
  return (
    <section className="relative py-24 sm:py-32 bg-[#0A0A0A] border-t border-white/5" data-testid="why-germany-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5 lg:sticky lg:top-32"
          >
            <span className="text-xs uppercase tracking-[0.32em] text-[#D4AF37]">Por qué Alemania</span>
            <h2 className="font-heading mt-6 text-3xl sm:text-5xl font-light tracking-tight text-[#FFFFF0] leading-tight">
              El mejor mercado de Europa, a tu alcance.
            </h2>
            <p className="mt-6 text-base text-[#A3A3A3] leading-relaxed font-light">
              Alemania no es solo el corazón industrial automotriz del continente.
              Es el mercado más transparente, profesional y con mayor oferta de
              vehículos premium, comerciales y familiares de Europa.
            </p>
            <div className="mt-10 grid grid-cols-2 gap-px bg-white/5 border border-white/5">
              <div className="bg-[#0A0A0A] p-6">
                <p className="font-heading text-3xl sm:text-4xl font-extralight gold-text">4.5M+</p>
                <p className="text-xs uppercase tracking-[0.2em] text-[#737373] mt-2">Vehículos disponibles</p>
              </div>
              <div className="bg-[#0A0A0A] p-6">
                <p className="font-heading text-3xl sm:text-4xl font-extralight gold-text">25%</p>
                <p className="text-xs uppercase tracking-[0.2em] text-[#737373] mt-2">Ahorro promedio</p>
              </div>
            </div>
          </motion.div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {reasons.map((r, i) => (
              <motion.div
                key={r.num}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="bg-white/[0.02] border border-white/5 p-8 hover:border-[#D4AF37]/30 hover:bg-white/[0.04] transition-all duration-500"
                data-testid={`why-germany-card-${i}`}
              >
                <span className="font-heading text-xs tracking-[0.3em] text-[#D4AF37]">{r.num}</span>
                <h3 className="font-heading text-lg sm:text-xl font-medium text-[#FFFFF0] mt-4 mb-3 leading-snug">{r.title}</h3>
                <p className="text-sm text-[#A3A3A3] leading-relaxed font-light">{r.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyGermany;
